import CardSummary from '@activities/prepaidCard/PrepaidCardLogActivity/components/CardSummary';
import Fab from '@activities/prepaidCard/PrepaidCardLogActivity/components/Fab';
import FilterBar from '@activities/prepaidCard/PrepaidCardLogActivity/components/FilterBar';
import BlankContent from '@components/blank/BlankContent';
import BlankEtc from '@components/blank/BlankEtc';
import BlankMyPrepaidCard from '@components/blank/BlankMyPrepaidCard';
import Column from '@components/Column';
import Divider from '@components/Divider';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import usePrepaidCardHistories from './hooks/usePrepaidCardHistories';
import LogItem from './LogItem';

interface Props {
    id: string;
}

function LogItems({ id }: Props) {
    const { t } = useTranslation('prepaidCard');
    const {
        histories, filter, setFilter, fetchNextPage, hasNextPage, isFetched,
    } = usePrepaidCardHistories(id);
    const isEmpty = isFetched && histories.length === 0;

    return (
        <Wrapper fullWidth>
            <CardSummary cardId={id} />
            <Divider />
            <Content>
                <FilterBar filter={filter} onChangeFilter={setFilter} />
                <List fullWidth>
                    {isEmpty ? (
                        <BlankEtc children={t('log.empty')} />
                    ) : (
                        histories.map((history) => (
                            <LogItem
                                key={`${history.orderNo}-${history.transactedAt}-${history.type}`}
                                history={history}
                            />
                        ))
                    )}
                    {hasNextPage && (
                        <InfinityScrollTrigger trigger={fetchNextPage} />
                    )}
                </List>
            </Content>
            <Fab />
        </Wrapper>
    );
}

const Wrapper = styled(Column)`
    background-color: var(--color-gray1);
    padding: 0 0 calc(80px + var(--safe-area-bottom));
`;

const List = styled(Column)`
    background-color: var(--color-white);
    overflow: hidden;
`;

const Content = styled.div`
    background-color: var(--color-white);
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    width: 100%;
`;

export default LogItems;
